export const url = {
  BASE_URL: "https://api.techitcheap.com/",
};